import { Component } from "@angular/core";

@Component({
    selector: "app-signin",
    template: "",
    standalone: false
})
export class SigninComponent { }
